import { AuthenticatedLayout } from "../../components/layout/AuthenticatedLayout";
import { useNavigate, useParams } from "react-router-dom";

export default function EventDetailPage() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  // Dummy event data
  const event = {
    id: Number(id),
    name: "Hội chợ từ thiện",
    date: "20/06/2023",
    time: "09:00 - 17:00",
    location: "Công viên Thống Nhất, Hà Nội",
    image: "https://placehold.co/400x200",
    organizer: "Hội Chữ thập đỏ Hà Nội",
    description:
      "Hội chợ từ thiện với mục đích gây quỹ cho trẻ em có hoàn cảnh khó khăn. Tại hội chợ sẽ có các gian hàng bán đồ handmade, đồ cũ, thức ăn và đồ uống. Toàn bộ số tiền thu được sẽ được quyên góp cho quỹ từ thiện.",
    participants: 120,
    maxParticipants: 200,
    isJoined: false,
    contact: {
      name: "Nguyễn Văn A",
      phone: "0987654321",
      email: "nguyenvana@example.com",
    },
  };

  const handleJoinEvent = () => {
    console.log("Join event:", id);
    // Implement join event logic here
  };

  const handleShareEvent = () => {
    console.log("Share event:", id);
    // Implement share event logic here
  };

  return (
    <AuthenticatedLayout>
      <div className="w-full h-full bg-[#FBF6F1] flex flex-col">
        {/* Header with image */}
        <div className="relative w-full h-56">
          <img
            src={event.image}
            alt={event.name}
            className="w-full h-full object-cover"
          />
          <div className="absolute top-4 left-4">
            <div
              className="size-10 bg-white/80 rounded-full flex items-center justify-center cursor-pointer"
              onClick={() => navigate(-1)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M15 6L9 12L15 18"
                  stroke="#1E3A3A"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
          <div className="absolute top-4 right-4 flex gap-2">
            <div
              className="size-10 bg-white/80 rounded-full flex items-center justify-center cursor-pointer"
              onClick={handleShareEvent}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M8.59 13.51L15.42 17.49M15.41 6.51L8.59 10.49M21 5C21 6.65685 19.6569 8 18 8C16.3431 8 15 6.65685 15 5C15 3.34315 16.3431 2 18 2C19.6569 2 21 3.34315 21 5ZM9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12ZM21 19C21 20.6569 19.6569 22 18 22C16.3431 22 15 20.6569 15 19C15 17.3431 16.3431 16 18 16C19.6569 16 21 17.3431 21 19Z"
                  stroke="#1E3A3A"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>

        {/* Event details */}
        <div className="flex flex-col p-4 gap-4">
          <h1 className="text-2xl font-medium font-inter text-midnight-blue">
            {event.name}
          </h1>

          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-2">
              <div className="size-5 relative overflow-hidden">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M6.66667 5.00001V3.33334M13.3333 5.00001V3.33334M5.83333 9.16667H14.1667M4.16667 16.6667H15.8333C16.7538 16.6667 17.5 15.9205 17.5 15V5.83334C17.5 4.91286 16.7538 4.16667 15.8333 4.16667H4.16667C3.24619 4.16667 2.5 4.91286 2.5 5.83334V15C2.5 15.9205 3.24619 16.6667 4.16667 16.6667Z"
                    stroke="#6F6F6B"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <span className="text-sm font-normal font-inter text-midnight-blue/60">
                {event.date}
              </span>
            </div>

            <div className="flex items-center gap-2">
              <div className="size-5 relative overflow-hidden">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M10 5.83334V10L12.5 12.5M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
                    stroke="#6F6F6B"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <span className="text-sm font-normal font-inter text-midnight-blue/60">
                {event.time}
              </span>
            </div>

            <div className="flex items-center gap-2">
              <div className="size-5 relative overflow-hidden">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M10.0001 9.16667C10.4603 9.16667 10.8334 8.79357 10.8334 8.33333C10.8334 7.8731 10.4603 7.5 10.0001 7.5C9.53984 7.5 9.16675 7.8731 9.16675 8.33333C9.16675 8.79357 9.53984 9.16667 10.0001 9.16667Z"
                    stroke="#6F6F6B"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M10.0001 16.6667C13.6821 16.6667 16.6667 13.0833 16.6667 8.33333C16.6667 3.58333 13.6821 0 10.0001 0C6.31818 0 3.33342 3.58333 3.33342 8.33333C3.33342 13.0833 6.31818 16.6667 10.0001 16.6667Z"
                    stroke="#6F6F6B"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <span className="text-sm font-normal font-inter text-[#6F6F6B]">
                {event.location}
              </span>
            </div>

            <div className="flex items-center gap-2">
              <div className="size-5 relative overflow-hidden">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M13.3333 5.83333C13.3333 3.53215 11.4678 1.66667 9.16667 1.66667C6.86548 1.66667 5 3.53215 5 5.83333C5 8.13452 6.86548 10 9.16667 10C11.4678 10 13.3333 8.13452 13.3333 5.83333Z"
                    stroke="#6F6F6B"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M2.5 18.3333C2.5 14.1912 5.48797 10.8333 9.16667 10.8333C12.8454 10.8333 15.8333 14.1912 15.8333 18.3333"
                    stroke="#6F6F6B"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M17.5 6.66667C17.5 4.82572 16.0076 3.33333 14.1667 3.33333"
                    stroke="#6F6F6B"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M18.3333 18.3333C18.3333 13.8182 16.8409 10.8333 14.1667 10.8333"
                    stroke="#6F6F6B"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <span className="text-sm font-normal font-inter text-[#6F6F6B]">
                {event.participants}/{event.maxParticipants} người tham gia
              </span>
            </div>
          </div>

          <div className="mt-2">
            <h2 className="text-lg font-medium font-inter text-midnight-blue mb-2">
              Mô tả
            </h2>
            <p className="text-sm font-normal font-inter text-midnight-blue/60">
              {event.description}
            </p>
          </div>

          <div className="mt-2">
            <h2 className="text-lg font-medium font-inter text-midnight-blue mb-2">
              Thông tin liên hệ
            </h2>
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium font-inter text-midnight-blue">
                  Người tổ chức:
                </span>
                <span className="text-sm font-normal font-inter text-midnight-blue/60">
                  {event.contact.name}
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium font-inter text-midnight-blue">
                  Số điện thoại:
                </span>
                <span className="text-sm font-normal font-inter text-midnight-blue/60">
                  {event.contact.phone}
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium font-inter text-midnight-blue">
                  Email:
                </span>
                <span className="text-sm font-normal font-inter text-midnight-blue/60">
                  {event.contact.email}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Join button */}
        <div className="mt-auto p-4">
          <button
            className="w-full py-3.5  rounded-full flex justify-center items-center gap-2.5"
            onClick={handleJoinEvent}
          >
            <div className="text-center text-pure-white text-sm font-medium font-inter leading-none">
              {event.isJoined ? "Đã tham gia" : "Tham gia"}
            </div>
          </button>
        </div>
      </div>
    </AuthenticatedLayout>
  );
}
